import { render, staticRenderFns } from "./externalLogin.vue?vue&type=template&id=125739c2&"
import script from "./externalLogin.vue?vue&type=script&lang=js&"
export * from "./externalLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports